module.exports = __webpack_public_path__ + "static/img/support_6.b2e1cda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/support_6.png
// module id = A+6D
// module chunks = 0